import React from "react";
import { Select } from "@shopify/polaris";
import { useTranslation } from "react-i18next";

interface YearMonthSelectProps {
  value: string;
  onChange: (yearMonth: string) => void;
  minYear?: number;
  maxYear?: number;
  label?: string;
}

const getYearMonthOptions = (min: number, max: number) => {
  const options = [];
  for (let y = max; y >= min; y--) {
    for (let m = 12; m >= 1; m--) {
      const month = m.toString().padStart(2, "0");
      options.push({
        label: `${y}-${month}`,
        value: `${y}-${month}`,
      });
    }
  }
  return options;
};

const YearMonthSelect: React.FC<YearMonthSelectProps> = ({
  value,
  onChange,
  minYear = 2000,
  maxYear = new Date().getFullYear(),
  label,
}) => {
  const options = getYearMonthOptions(minYear, maxYear);
  const { t } = useTranslation();
  return (
    <div style={{ marginBottom: 5 }}>
      <Select
        label={label || t("year_month_select")}
        labelHidden
        options={options}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default YearMonthSelect;
